// extracted by mini-css-extract-plugin
module.exports = {"Sell__heading":"styles-module--Sell__heading--1iWlQ","Sell__description":"styles-module--Sell__description--5fuTE","Sell__whyImage":"styles-module--Sell__whyImage--2yzis"};